<template>
  <MainLayout>
    <b-row>
      <b-col
        class="shadow-sm"
        style
      >
        <b-card-body>
          <u-error-handling
            v-if="errorObject"
            :error-object="errorObject"
          />

          <h4
            class="card-title font-weight-bold"
            style="margin-bottom: 40px"
          >
            Vertragssuche
          </h4>

          <div id="contractsSearchMainArguments col-12">
            <div class="form-group">
              <label
                class="pl-0 col-4 defaultLabel"
                for="filter"
              >Vertragsnummer/ Name</label>
              <div>
                <input
                  id="gavNumberNameSearchBox"
                  v-model="filterGavNumberName"
                  :class="{ 'filled-input': filterGavNumberName }"
                  class="custom-input col-6"
                  placeholder="Vertragsnummer/ Name"
                  type="text"
                >
              </div>
            </div>
          </div>

          <transition name="slide">
            <div
              v-show="showAdvancedSearch"
              id="contractsSearchAdvancedArguments"
            >
              <!-- Version Status -->
              <div
                v-if="versionStatus && versionStatus.length"
                class="form-group pt-2"
              >
                <label class="pl-0 col-4 defaultLabel">Version-Status</label>
                <div>
                  <select
                    id="versionStatusSearchSelect"
                    v-model="filterVersionState"
                    :class="{ 'filled-input': filterVersionState != -1 }"
                    class="custom-select col-6"
                    lazy
                    title="Version-Status"
                    type="text"
                  >
                    <option :value="-1">
                      Version-Status wählen
                    </option>
                    <option
                      v-for="(versionState, index) in versionStatus"
                      :key="index"
                      :value="versionState.id"
                    >
                      {{ versionState.name }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- Version Tags -->
              <div class="form-group pt-2">
                <label class="pl-0 col-4 defaultLabel">Version-Tags</label>
                <div>
                  <select
                    id="VersiontagSearchSelect"
                    v-model="filterVersionTag"
                    :class="{ 'filled-input': filterVersionTag != -1 }"
                    class="custom-select col-6"
                    lazy
                    title="Version-Tag"
                    type="text"
                  >
                    <option :value="-1">
                      Version-Tags wählen
                    </option>
                    <option
                      v-for="(versionTag, index) in versionTags"
                      :key="index"
                      :value="versionTag"
                    >
                      {{ versionTag }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- Version mit dem Tenant y -->
              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                >Version mit Tenant</label>
                <div>
                  <select
                    id="aveStatusSearchSelect"
                    v-model="filterVersionTenant"
                    :class="{ 'filled-input': filterVersionTenant != -1 }"
                    class="custom-select col-6"
                    lazy
                    title="AVE-Status"
                    type="text"
                  >
                    <option :value="-1">
                      Version mit Tenant
                    </option>
                    <option
                      v-for="(availableTenant, index) in availableTenants"
                      :key="index"
                      :value="availableTenant.id"
                    >
                      {{ availableTenant.bezeichnung }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Version gültig ab -->
              <!--
              year_version_valid_from: "",
              month_version_valid_from: "",
              day_version_valid_from: "",
              date_version_valid_from: null, null, -->
              <div class="form-group pt-2">
                <label class="pl-0 col-4 defaultLabel">Version gültig ab</label>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="mb-0 font-weight-bold">Jahr </label>
                  <select
                    v-model="year_version_valid_from"
                    :class="{
                      'filled-input': year_version_valid_from != 0,
                    }"
                    class="custom-select"
                  >
                    <option value="">
                      Jahr wählen
                    </option>
                    <option
                      v-for="year in validYears"
                      :key="year"
                      :value="year"
                    >
                      {{ year }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Monat </label>
                  <select
                    v-model="month_version_valid_from"
                    :class="{ 'filled-input': month_version_valid_from != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Monat wählen
                    </option>
                    <option
                      v-for="month in validMonths"
                      :key="month"
                      :value="month"
                    >
                      {{ month }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2 pr-0"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Tag </label>
                  <select
                    v-model="day_version_valid_from"
                    :class="{ 'filled-input': day_version_valid_from != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Tag wählen
                    </option>
                    <option
                      v-for="day in validDays(
                        year_version_valid_from,
                        month_version_valid_from,
                      )"
                      :key="day"
                      :value="day"
                    >
                      {{ day }}
                    </option>
                  </select>
                </div>

                <div
                  class="col-2"
                  style="display: inline-block !important"
                >
                  <v-checkbox
                    v-model="exact_version_valid_from"
                    :color="UNIA_RED"
                    :label="GENAUESDATUM_LABEL"
                  />
                </div>
              </div>

              <!-- Version gültig bis -->
              <!-- Versionen, die bis «Datum» gültig sind
              year_version_valid_to: "",
              month_version_valid_to: "",
              day_version_valid_to: "",
              date_version_valid_to: null -->
              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                >Version gültig bis</label>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="mb-0 font-weight-bold">Jahr </label>
                  <select
                    v-model="year_version_valid_to"
                    :class="{ 'filled-input': year_version_valid_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Jahr wählen
                    </option>
                    <option
                      v-for="year in validYearsTo"
                      :key="year"
                      :value="year"
                    >
                      {{ year }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Monat </label>
                  <select
                    v-model="month_version_valid_to"
                    :class="{ 'filled-input': month_version_valid_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Monat wählen
                    </option>
                    <option
                      v-for="month in validMonths"
                      :key="month"
                      :value="month"
                    >
                      {{ month }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2 pr-0"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Tag </label>
                  <select
                    v-model="day_version_valid_to"
                    :class="{ 'filled-input': day_version_valid_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Tag wählen
                    </option>
                    <option
                      v-for="day in validDays(
                        year_version_valid_to,
                        month_version_valid_to,
                      )"
                      :key="day"
                      :value="day"
                    >
                      {{ day }}
                    </option>
                  </select>
                </div>

                <div
                  class="col-2"
                  style="display: inline-block !important"
                >
                  <v-checkbox
                    v-model="exact_version_valid_to"
                    :color="UNIA_RED"
                    :label="GENAUESDATUM_LABEL"
                  />
                </div>
              </div>
              <!-- has Anhnag 1 -->
              <div
                v-if="anhang1Status && anhang1Status.length"
                class="form-group pt-2"
              >
                <label class="pl-0 col-4 defaultLabel">Anhang 1</label>
                <div>
                  <v-checkbox
                    v-model="hasAnhang1"
                    :color="UNIA_RED"
                    class="mt-0 pt-0 mb-0 pb-0"
                  />
                </div>
              </div>
              <!-- Anhnag 1 Status -->
              <div
                v-if="anhang1Status && anhang1Status.length && hasAnhang1"
                class="form-group pt-2"
              >
                <label class="pl-0 col-4 defaultLabel">Anhang 1-Status</label>
                <div>
                  <select
                    id="filterAhnhang1StateSearchSelect"
                    v-model="filterAhnhang1State"
                    :class="{ 'filled-input': filterAhnhang1State != -1 }"
                    class="custom-select col-6"
                    lazy
                    title="Anhang1-Status"
                    type="text"
                  >
                    <option :value="-1">
                      Anhang 1-Status wählen
                    </option>
                    <option
                      v-for="(anhang1State, index) in anhang1Status"
                      :key="index"
                      :value="anhang1State.id"
                    >
                      {{ anhang1State.name }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- is AVE -->
              <div
                v-if="aveStateList && aveStateList.length"
                class="form-group pt-2"
              >
                <label class="pl-0 col-4 defaultLabel">AVE</label>
                <div>
                  <v-checkbox
                    v-model="hasAve"
                    :color="UNIA_RED"
                    class="mt-0 pt-0 mb-0 pb-0"
                  />
                </div>
              </div>

              <!-- AVE-Status -->
              <div
                v-if="aveStateList && aveStateList.length && hasAve"
                class="form-group pt-2"
              >
                <label class="pl-0 col-4 defaultLabel">AVE-Status</label>
                <div>
                  <select
                    id="aveStatusSearchSelect"
                    v-model="filterAveState"
                    :class="{ 'filled-input': filterAveState != -1 }"
                    class="custom-select col-6"
                    lazy
                    title="AVE-Status"
                    type="text"
                  >
                    <option :value="-1">
                      AVE-Status wählen
                    </option>
                    <option
                      v-for="(aveState, index) in aveStateList"
                      :key="index"
                      :value="aveState.id"
                    >
                      {{ aveState.name }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- AVE Änderungen gültig ab -->
              <!-- Versionen, deren AVE Änderungen gültig ab
              year_ave_changes_from: "",
              month_ave_changes_from: "",
              day_ave_changes_from: "",
              date_ave_changes_from: null, -->
              <div
                v-if="hasAve"
                class="form-group pt-2"
              >
                <label
                  class="pl-0 col-4 defaultLabel"
                >AVE Änderungen gültig ab</label>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label
                    class="custom-label mb-0 font-weight-bold"
                  >Jahr
                  </label>
                  <select
                    v-model="year_ave_changes_from"
                    :class="{ 'filled-input': year_ave_changes_from != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Jahr wählen
                    </option>
                    <option
                      v-for="year in validYears"
                      :key="year"
                      :value="year"
                    >
                      {{ year }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Monat </label>
                  <select
                    v-model="month_ave_changes_from"
                    :class="{ 'filled-input': month_ave_changes_from != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Monat wählen
                    </option>
                    <option
                      v-for="month in validMonths"
                      :key="month"
                      :value="month"
                    >
                      {{ month }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2 pr-0"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Tag </label>
                  <select
                    v-model="day_ave_changes_from"
                    :class="{ 'filled-input': day_ave_changes_from != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Tag wählen
                    </option>
                    <option
                      v-for="day in validDays(
                        year_ave_changes_from,
                        month_ave_changes_from,
                      )"
                      :key="day"
                      :value="day"
                    >
                      {{ day }}
                    </option>
                  </select>
                </div>

                <div
                  class="col-2"
                  style="display: inline-block !important"
                >
                  <v-checkbox
                    v-model="exact_ave_changes_from"
                    :color="UNIA_RED"
                    :label="GENAUESDATUM_LABEL"
                  />
                </div>
              </div>

              <!-- AVE Änderungen gültig bis -->
              <!-- Versionen, deren AVE Änderungen gültig bis
              year_ave_changes_to: "",
              month_ave_changes_to: "",
              day_ave_changes_to: "",
              date_ave_changes_to: null, -->
              <div
                v-if="hasAve"
                class="form-group pt-2"
              >
                <label
                  class="pl-0 col-4 defaultLabel"
                >AVE Änderungen gültig bis</label>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="mb-0 font-weight-bold">Jahr </label>
                  <select
                    v-model="year_ave_changes_to"
                    :class="{ 'filled-input': year_ave_changes_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Jahr wählen
                    </option>
                    <option
                      v-for="year in validYearsTo"
                      :key="year"
                      :value="year"
                    >
                      {{ year }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Monat </label>
                  <select
                    v-model="month_ave_changes_to"
                    :class="{ 'filled-input': month_ave_changes_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Monat wählen
                    </option>
                    <option
                      v-for="month in validMonths"
                      :key="month"
                      :value="month"
                    >
                      {{ month }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2 pr-0"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Tag </label>
                  <select
                    v-model="day_ave_changes_to"
                    :class="{ 'filled-input': day_ave_changes_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Tag wählen
                    </option>
                    <option
                      v-for="day in validDays(
                        year_ave_changes_to,
                        month_ave_changes_to,
                      )"
                      :key="day"
                      :value="day"
                    >
                      {{ day }}
                    </option>
                  </select>
                </div>

                <div
                  class="col-2"
                  style="display: inline-block !important"
                >
                  <v-checkbox
                    v-model="exact_ave_changes_to"
                    :color="UNIA_RED"
                    :label="GENAUESDATUM_LABEL"
                  />
                </div>
              </div>

              <!-- Versionen, deren Künstliche Verlängerung gültig bis
              year_ave_extend_to: "",
              month_ave_extend_to: "",
              day_ave_extend_to: "",
              date_ave_extend_to: null, -->
              <!-- Künstliche Verlängerung bis -->
              <div
                v-if="hasAve"
                class="form-group pt-2"
              >
                <label
                  class="pl-0 col-4 defaultLabel"
                >Künstliche Verlängerung bis</label>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="mb-0 font-weight-bold">Jahr </label>
                  <select
                    v-model="year_ave_extend_to"
                    :class="{ 'filled-input': year_ave_extend_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Jahr wählen
                    </option>
                    <option
                      v-for="year in validYears"
                      :key="year"
                      :value="year"
                    >
                      {{ year }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Monat </label>
                  <select
                    v-model="month_ave_extend_to"
                    :class="{ 'filled-input': month_ave_extend_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Monat wählen
                    </option>
                    <option
                      v-for="month in validMonths"
                      :key="month"
                      :value="month"
                    >
                      {{ month }}
                    </option>
                  </select>
                </div>

                <div
                  class="pl-0 col-2 pr-0"
                  style="display: inline-block !important"
                >
                  <label class="font-weight-bold mb-0">Tag </label>
                  <select
                    v-model="day_ave_extend_to"
                    :class="{ 'filled-input': day_ave_extend_to != 0 }"
                    class="custom-select"
                  >
                    <option value="">
                      Tag wählen
                    </option>
                    <option
                      v-for="day in validDays(
                        year_ave_extend_to,
                        month_ave_extend_to,
                      )"
                      :key="day"
                      :value="day"
                    >
                      {{ day }}
                    </option>
                  </select>
                </div>
                <div
                  class="col-2"
                  style="display: inline-block !important"
                >
                  <!--                  TODO-->
                  <v-checkbox
                    v-model="exact_ave_extend_to"
                    :color="UNIA_RED"
                    :label="GENAUESDATUM_LABEL"
                  />
                </div>
              </div>
              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                  for="exampleInputEmail1"
                >Wf. Status</label>
                <div>
                  <select
                    id="wfStatusSearchSelect"
                    v-model="filterWorkflowStatus"
                    :class="{ 'filled-input': filterWorkflowStatus != -1 }"
                    class="custom-select col-6"
                    lazy
                    title="Workflow Status"
                    type="text"
                  >
                    <option
                      v-for="wfStatus in workflowStatusList"
                      :key="wfStatus.id"
                      :value="wfStatus.id"
                    >
                      {{ wfStatus.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                >Meine Versionen/Editionen</label>
                <div>
                  <v-checkbox
                    v-model="filterOnlyMyContracts"
                    :color="UNIA_RED"
                    class="pt-0 mt-0"
                  />
                </div>
              </div>
              <div class="form-group">
                <label
                  class="pl-0 col-4 defaultLabel"
                >Aktualisierte Versionen/Editionen ausblenden</label>
                <div>
                  <v-checkbox
                    v-model="filterHidePublishedContracts"
                    :color="UNIA_RED"
                    class="pt-0 mt-0"
                  />
                </div>
              </div>
              <div class="form-group">
                <label
                  class="pl-0 col-4 defaultLabel"
                >Deaktivierte Versionen/Editionen ausblenden</label>
                <div>
                  <v-checkbox
                    v-model="filterHideInactiveContracts"
                    :color="UNIA_RED"
                    class="pt-0 mt-0"
                  />
                </div>
              </div>
              <div class="form-group">
                <label
                  class="pl-0 col-4 defaultLabel"
                >nur abgelaufene Verträge</label>
                <div>
                  <v-checkbox
                    v-model="filterOnlyExpiredContracts"
                    :color="UNIA_RED"
                    class="pt-0 mt-0"
                  />
                </div>
              </div>

              <div class="form-group">
                <label
                  class="pl-0 col-4 defaultLabel"
                >Nur neuste Version</label>
                <div>
                  <v-checkbox
                    v-model="filterOnlyLastVersion"
                    :color="UNIA_RED"
                    class="pt-0 mt-0"
                  />
                </div>
              </div>

              <div class="form-group">
                <label
                  class="pl-0 col-4 defaultLabel"
                >Nur letzte aktualisierte Version/Edition</label>

                <div>
                  <v-checkbox
                    v-model="filterOnlyUpdatedLastVersion"
                    :color="UNIA_RED"
                    class="pt-0 mt-0"
                  />
                </div>
              </div>

              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                  for="exampleInputEmail1"
                >Verantwortung Erfassung</label>
                <div>
                  <v-autocomplete
                    v-model="filterResponsableUserId"
                    :filter="filterVersionresponsables"
                    :items="versionResponsables"
                    class="p-0 m-0 col-6"
                    clearable
                    item-value="id"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      <div class="m-2">
                        {{ data.item.lastname }} - {{ data.item.firstname }}
                      </div>
                    </template>

                    <template
                      slot="item"
                      slot-scope="data"
                    >
                      <div class="m-2">
                        {{ data.item.lastname }} - {{ data.item.firstname }}
                      </div>
                    </template>
                  </v-autocomplete>
                </div>
              </div>

              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                  for="exampleInputEmail1"
                >Kontrolle Erfassung</label>
                <div>
                  <v-autocomplete
                    v-model="filterControllerUserId"
                    :filter="filterVersionresponsables"
                    :items="versionResponsables"
                    class="p-0 m-0 col-6"
                    clearable
                    item-value="id"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      <div class="m-2">
                        {{ data.item.lastname }} - {{ data.item.firstname }}
                      </div>
                    </template>

                    <template
                      slot="item"
                      slot-scope="data"
                    >
                      <div class="m-2">
                        {{ data.item.lastname }} - {{ data.item.firstname }}
                      </div>
                    </template>
                  </v-autocomplete>
                </div>
              </div>

              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                  for="exampleInputEmail1"
                >GAV-Verantwortliche Person</label>
                <div>
                  <v-autocomplete
                    v-model="filterContractResponsable"
                    :filter="filterContractresponsables"
                    :items="contractResponsables"
                    class="p-0 m-0 col-6"
                    clearable
                    return-object
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      <div class="m-2">
                        {{ data.item.name }}
                      </div>
                    </template>

                    <template
                      slot="item"
                      slot-scope="data"
                    >
                      <div class="m-2">
                        {{ data.item.name }}
                      </div>
                    </template>
                  </v-autocomplete>
                </div>
              </div>

              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                  for="exampleInputEmail1"
                >Vertragstyp</label>
                <div>
                  <v-autocomplete
                    v-model="filterContractTypeId"
                    :items="contractTypes"
                    class="p-0 m-0 col-6"
                    clearable
                    item-text="name"
                    item-value="id"
                  />
                </div>
              </div>

              <div class="form-group pt-2">
                <label
                  class="pl-0 col-4 defaultLabel"
                  for="exampleInputEmail1"
                >Struktur-Element aus MiloKonfig</label>
                <div>
                  <v-autocomplete
                    v-model="filterCriteriaStructureItem"
                    :filter="filterCriteriaStructure"
                    :items="criteriaStructurelist"
                    class="p-0 m-0 col-6"
                    clearable
                    item-value="code"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      <div class="m-2">
                        {{ data.item.code }}
                      </div>
                    </template>

                    <template
                      slot="item"
                      slot-scope="data"
                    >
                      <div class="m-2">
                        {{ data.item.code }}
                      </div>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>
          </transition>
          <div id="contractsTableControlPanel">
            <div class="advancedSearchButtonsWrapper">
              <button
                class="btn btn-link pb-0"
                href="#"
                @click="hideShowAdvancedSearch()"
              >
                <div v-show="!showAdvancedSearch">
                  Erweiterte Suche anzeigen
                </div>
                <div v-show="showAdvancedSearch">
                  Erweiterte Suche ausblenden
                </div>
              </button>
              <br>
              <button
                class="btn btn-link pt-0"
                href="#"
                @click="resetFilters"
              >
                alle Filter zurücksetzen
              </button>
              <br>
              <button
                :disabled="isActivAllResToBookmarks"
                class="btn btn-link pt-0"
                href="#"
                @click="setBookmarkOnAll"
              >
                alle Resultate der Merkliste hinzufügen
              </button>
            </div>
            <div style="width: 100%; margin-bottom: 5px; height: 40px">
              <span>
                <Create-New-Contract-Button class="float-right" />
              </span>
            </div>
            <div style="width: 100%; margin-bottom: 5px">
              <b-select
                v-model="resultsPerPage"
                style="width: 62px; height: 31px; font-size: 12px"
              >
                <option :value="10">
                  10
                </option>
                <option :value="25">
                  25
                </option>
                <option :value="50">
                  50
                </option>
                <option :value="100">
                  100
                </option>
              </b-select>
              <label
                style="font-weight: bold; margin-left: 3px"
              >Anzahl Resultate</label>
              <b-pagination
                v-model="currentPage"
                :per-page="resultsPerPage"
                :total-rows="totalNumberOfContracts"
                class="float-right"
                first-text="<<"
                last-text=">>"
                next-text="Nächste"
                prev-text="Vorherige"
              />
            </div>
            <template v-if="totalNumberOfContracts > 0">
              {{ fromContracts + 1 }} bis {{ toContracts }} von
              {{ totalNumberOfContracts }} Resultaten
            </template>
            <template v-else>
              keine Resultate
            </template>
          </div>
          <u-loader
            v-if="isLoading"
            :class="{ isActive: isLoading, isInactive: !isLoading }"
            class="loader"
          />
          <div
            v-else
            class="rTable"
          >
            <div class="rTableRow">
              <div
                class="rTableHead contractsTableGavNumber cursor-pointer"
                @click="SortedPropertyClicked('ContractNumber')"
              >
                <span class="float-left mr-1">Vertragsnummer</span>
                <u-sorting-up-down
                  :value="SortedProperty == 'ContractNumber' ? SortOrder : -1"
                />
              </div>
              <div
                class="rTableHead contractsTableLastChange cursor-pointer"
                @click="SortedReversePropertyClicked('VersionModified')"
              >
                <span class="float-left mr-1">Letzte Änderung</span>
                <u-sorting-up-down
                  :value="SortedProperty == 'VersionModified' ? SortOrder : -1"
                />
              </div>
              <div
                class="rTableHead contractsTableName cursor-pointer"
                @click="SortedPropertyClicked('ContractName')"
              >
                <span class="float-left mr-1">Name</span>
                <u-sorting-up-down
                  :value="SortedProperty == 'ContractName' ? SortOrder : -1"
                />
              </div>
              <div
                class="rTableHead contractsTableStart cursor-pointer"
                @click="SortedReversePropertyClicked('VersionValidFrom')"
              >
                <span class="float-left mr-1">Start</span>
                <u-sorting-up-down
                  :value="SortedProperty == 'VersionValidFrom' ? SortOrder : -1"
                />
              </div>
              <div
                class="rTableHead contractsTableEnd cursor-pointer"
                @click="SortedReversePropertyClicked('VersionValidTo')"
              >
                <span class="float-left mr-1">Ende</span>
                <u-sorting-up-down
                  :value="SortedProperty == 'VersionValidTo' ? SortOrder : -1"
                />
              </div>
              <div
                class="rTableHead contractsTableVersion cursor-pointer"
                @click="SortedPropertyClicked('VersionNumber')"
              >
                <span class="float-left mr-1">Version</span>
                <u-sorting-up-down
                  :value="SortedProperty == 'VersionNumber' ? SortOrder : -1"
                />
              </div>
              <div
                class="rTableHead contractsTableVersionState cursor-pointer"
                @click="SortedPropertyClicked('VersionState')"
              >
                <span class="float-left mr-1"> Version-Status</span>
                <!-- <u-sorting-up-down :value="SortedProperty == 'VersionState' ? SortOrder : -1" /> -->
                <!-- @click="SortedPropertyClicked('VersionState')" -->
                <u-sorting-up-down
                  :value="SortedProperty == 'VersionState' ? SortOrder : -1"
                />
              </div>
              <div
                class="rTableHead contractsTableWfStatus cursor-pointer"
                @click="SortedPropertyClicked('WorkflowStatusId')"
              >
                <span class="float-left mr-1">Wf. Status</span>

                <u-sorting-up-down
                  :value="SortedProperty == 'WorkflowStatusId' ? SortOrder : -1"
                />
              </div>

              <div
                class="rTableHead contractsTableAveStatus cursor-pointer"
                @click="SortedPropertyClicked('AveStatus')"
              >
                <span class="float-left mr-1">AVE-Status</span>
                <u-sorting-up-down
                  :value="SortedProperty == 'AveStatus' ? SortOrder : -1"
                />
              </div>

              <div class="rTableHead contractsTableWfStatus">
                Merkliste
              </div>
            </div>
            <div
              v-for="(contract, index) in allContracts"
              :key="index"
              class="col-12 rTableRow"
            >
              <div class="rTableCell contractsTableGavNumber">
                {{ contract.contractNumber }}
              </div>
              <div class="rTableCell contractsTableLastChange">
                {{ contract.versionModified | moment("DD.MM.YYYY") }} <br>
                {{ contract.versionModified | moment("HH:mm:ss") }}
              </div>
              <div class="rTableCell contractsTableName">
                <router-link
                  :to="
                    '/contract-overview/' +
                      contract.contractNumber +
                      '/' +
                      contract.versionNumber
                  "
                >
                  {{
                    contract.contractName
                      ? contract.contractName
                      : `${contract.contractNumber}-${contract.versionNumber}`
                  }}
                </router-link>
              </div>
              <div class="rTableCell contractsTableStart">
                {{ contract.versionValidFrom | moment("DD.MM.YYYY") }}
              </div>
              <div class="rTableCell contractsTableEnd">
                {{ contract.versionValidTo | moment("DD.MM.YYYY") }}
              </div>
              <div class="rTableCell contractsTableVersion">
                {{ contract.versionNumber }}
              </div>
              <div class="rTableCell contractsTableVersionState">
                {{ getVersionState(contract.versionState) }}
              </div>
              <div class="rTableCell contractsTableWfStatus">
                <u-workflow-state-icons :states="contract.workflowStates" />
              </div>

              <div
                v-if="
                  aveStateList &&
                    aveStateList.length &&
                    contract &&
                    'aveState' in contract
                "
                class="rTableCell contractsTableAveStatus"
              >
                <div
                  v-if="
                    contract.aveState !== -1 &&
                      'name' in aveStateList[contract.aveState]
                  "
                >
                  {{ aveStateList[contract.aveState].name }}
                </div>
                <div v-else>
                  --
                </div>
              </div>

              <div class="rTableCell contractsTableWfStatus">
                <v-checkbox
                  v-model="contract.isBookmark"
                  class="pt-0 mt-3"
                  color="#ff0000"
                  @change="setBookmark(contract)"
                />
              </div>
            </div>
          </div>

          <div style="width: 100%; margin-top: 25px">
            <b-pagination
              v-model="currentPage"
              :per-page="resultsPerPage"
              :total-rows="totalNumberOfContracts"
              class="float-right"
              first-text="<<"
              last-text=">>"
              next-text="Nächste"
              prev-text="Vorherige"
            />
          </div>
        </b-card-body>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import {
  GetAllContracts,
  GetAveStatus,
  GetVersionStatus,
  GetVersionTags,
  GetAnhang1Status,
  GetCriteriaStructurelist,
  GetVersionResponsables,
  GetContractResponsables,
  GetContractTypes,
} from "@/services/contract.service.js";
import USortingUpDown from "@/components/common/USortingUpDown.vue";
import UWorkflowStateIcons from "@/components/common/UWorkflowStateIcons.vue";
import CreateNewContractButton from "@/components/contract/CreateNewContractButton.vue";
import { setTimeout } from "timers";
import { UniaGAVConstants } from "@/assets/configuration/constants.js";
import {
  addItemToMerkliste,
  addItemsToMerkliste,
  loadMerkliste,
  removeSingleItemFromMerkliste,
} from "@/helpers/BookmarksHelper.js";
import { GetAllEditions } from "@/services/contract.edition.service.js";
import { GetAvailableTenants } from "@/services/contract.tenants.service.js";

export default {
  components: {
    MainLayout,
    USortingUpDown,
    UWorkflowStateIcons,
    CreateNewContractButton,
  },
  data() {
    return {
      allContracts: [],
      totalNumberOfContracts: 0,
      currentPage: 1,
      isLoading: false,
      errorObject: null,
      fromContracts: 0,
      toContracts: 0,
      SortOrder: 1,
      SortedProperty: "",
      gavNumber: "",
      filterGavName: "",
      filterGavNumber: "",
      filterGavNumberName: "",
      filterWorkflowStatus: -1,
      filterAveState: -1,
      filterAhnhang1State: -1,
      filterVersionTag: -1,
      filterVersionState: -1,
      filterVersionTenant: -1,
      filterOnlyMyContracts: false,
      filterHidePublishedContracts: false,
      filterHideInactiveContracts: false,
      filterOnlyExpiredContracts: false,
      filterOnlyLastVersion: false,
      filterOnlyUpdatedLastVersion: false,
      filterContractResponsable: "",
      searchQueryQueue: [],
      resultsPerPage: 25,
      showAdvancedSearch: false,
      merkListe: [],
      versionStatus: [],
      versionTags: [],
      aveStateList: [],
      availableTenants: [],
      anhang1Status: [],
      workflowStatusList: [
        { id: -1, text: "Workflow Status wählen" },
        { id: 1, text: "Edit" },
        { id: 3, text: "Aktualisiert" },
        { id: 5, text: "Deactivated" },
      ],
      hasAnhang1: false,
      hasAve: false,
      criteriaStructurelist: [],
      versionResponsables: [],
      contractResponsables: [],
      filterResponsableUserId: "",
      filterControllerUserId: "",
      filterCriteriaStructureItem: "",
      //Versionen, deren AVE Änderungen gültig ab
      year_ave_changes_from: "",
      month_ave_changes_from: "",
      day_ave_changes_from: "",
      date_ave_changes_from: "",
      exact_ave_changes_from: false,
      //Versionen, deren AVE Änderungen gültig bis
      year_ave_changes_to: "",
      month_ave_changes_to: "",
      day_ave_changes_to: "",
      date_ave_changes_to: "",
      exact_ave_changes_to: false,
      //Versionen, deren Künstliche Verlängerung gültig bis
      year_ave_extend_to: "",
      month_ave_extend_to: "",
      day_ave_extend_to: "",
      date_ave_extend_to: "",
      exact_ave_extend_to: false,
      //Versionen, die ab «Datum» gültig sind
      year_version_valid_from: "",
      month_version_valid_from: "",
      day_version_valid_from: "",
      date_version_valid_from: "",
      exact_version_valid_from: false,
      //Versionen, die bis «Datum» gültig sind
      year_version_valid_to: "",
      month_version_valid_to: "",
      day_version_valid_to: "",
      date_version_valid_to: "",
      exact_version_valid_to: false,
      //Konstante Werte
      GENAUESDATUM_LABEL: "genaues Datum",
      UNIA_RED: "#e72b37",
      disableLocalStorageSave: true,
      isActivAllResToBookmarks: false,
      filterContractTypeId: "",
      contractTypes: [],
    };
  },
  computed: {
    validYears() {
      const startYear = 1990;
      const endYear = 2040;

      return Array.from(
        { length: endYear - startYear },
        (_, index) => startYear + index,
      );
    },
    validYearsTo() {
      const startYear = 1990;
      const endYear = 2040;

      return Array.from(
        { length: endYear - startYear },
        (_, index) => startYear + index,
      );
    },
    validMonths() {
      return Array.from({ length: 12 }, (_, index) => index + 1);
    },
  },
  watch: {
    // Versionen, deren AVE Änderungen gültig ab
    // year_ave_changes_from: "",
    // month_ave_changes_from: "",
    // day_ave_changes_from: "",
    // date_ave_changes_from: null,
    year_ave_changes_from() {
      this.date_ave_changes_from = this.checkDate(
        this.year_ave_changes_from,
        this.month_ave_changes_from,
        this.day_ave_changes_from,
        this.date_ave_changes_from,
        "firstDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    month_ave_changes_from() {
      this.date_ave_changes_from = this.checkDate(
        this.year_ave_changes_from,
        this.month_ave_changes_from,
        this.day_ave_changes_from,
        this.date_ave_changes_from,
        "firstDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    day_ave_changes_from() {
      this.date_ave_changes_from = this.checkDate(
        this.year_ave_changes_from,
        this.month_ave_changes_from,
        this.day_ave_changes_from,
        this.date_ave_changes_from,
        "firstDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    // Versionen, deren AVE Änderungen gültig bis
    // year_ave_changes_to: "",
    // month_ave_changes_to: "",
    // day_ave_changes_to: "",
    // date_ave_changes_to: null,
    year_ave_changes_to() {
      this.date_ave_changes_to = this.checkDate(
        this.year_ave_changes_to,
        this.month_ave_changes_to,
        this.day_ave_changes_to,
        this.date_ave_changes_to,
        "lastDay",
      );
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    month_ave_changes_to() {
      this.date_ave_changes_to = this.checkDate(
        this.year_ave_changes_to,
        this.month_ave_changes_to,
        this.day_ave_changes_to,
        this.date_ave_changes_to,
        "lastDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    day_ave_changes_to() {
      this.date_ave_changes_to = this.checkDate(
        this.year_ave_changes_to,
        this.month_ave_changes_to,
        this.day_ave_changes_to,
        this.date_ave_changes_to,
        "lastDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    // Versionen, deren Künstliche Verlängerung gültig bis
    // year_ave_extend_to: "",
    // month_ave_extend_to: "",
    // day_ave_extend_to: "",
    // date_ave_extend_to: null,
    year_ave_extend_to() {
      this.date_ave_extend_to = this.checkDate(
        this.year_ave_extend_to,
        this.month_ave_extend_to,
        this.day_ave_extend_to,
        this.date_ave_extend_to,
        "lastDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    month_ave_extend_to() {
      this.date_ave_extend_to = this.checkDate(
        this.year_ave_extend_to,
        this.month_ave_extend_to,
        this.day_ave_extend_to,
        this.date_ave_extend_to,
        "lastDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    day_ave_extend_to() {
      this.date_ave_extend_to = this.checkDate(
        this.year_ave_extend_to,
        this.month_ave_extend_to,
        this.day_ave_extend_to,
        this.date_ave_extend_to,
        "lastDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    // Versionen, die ab «Datum» gültig sind
    // year_version_valid_from: "",
    // month_version_valid_from: "",
    // day_version_valid_from: "",
    // date_version_valid_from: null,
    year_version_valid_from() {
      this.date_version_valid_from = this.checkDate(
        this.year_version_valid_from,
        this.month_version_valid_from,
        this.day_version_valid_from,
        this.date_version_valid_from,
        "firstDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    month_version_valid_from() {
      this.date_version_valid_from = this.checkDate(
        this.year_version_valid_from,
        this.month_version_valid_from,
        this.day_version_valid_from,
        this.date_version_valid_from,
        "firstDay",
      );
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    day_version_valid_from() {
      this.date_version_valid_from = this.checkDate(
        this.year_version_valid_from,
        this.month_version_valid_from,
        this.day_version_valid_from,
        this.date_version_valid_from,
        "firstDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    // Versionen, die bis «Datum» gültig sind
    // year_version_valid_to: "",
    // month_version_valid_to: "",
    // day_version_valid_to: "",
    // date_version_valid_to: null
    year_version_valid_to() {
      this.date_version_valid_to = this.checkDate(
        this.year_version_valid_to,
        this.month_version_valid_to,
        this.day_version_valid_to,
        this.date_version_valid_to,
        "lastDay",
      );
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    month_version_valid_to() {
      this.date_version_valid_to = this.checkDate(
        this.year_version_valid_to,
        this.month_version_valid_to,
        this.day_version_valid_to,
        this.date_version_valid_to,
        "lastDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    day_version_valid_to() {
      this.date_version_valid_to = this.checkDate(
        this.year_version_valid_to,
        this.month_version_valid_to,
        this.day_version_valid_to,
        this.date_version_valid_to,
        "lastDay",
      );

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },

    currentPage() {
      this.GetAllContractsFiltered();
    },

    filterVersionState() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterVersionTag() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterVersionTenant() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterAhnhang1State() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterAveState() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterGavName() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterGavNumber() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterGavNumberName() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterWorkflowStatus() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    SortedProperty() {
      this.SortOrder = 0;

      if (
        this.SortedProperty == "VersionModified" ||
        this.SortedProperty == "VersionValidTo" ||
        this.SortedProperty == "VersionValidFrom" ||
        this.SortedProperty == "versionState"
      ) {
        this.SortOrder = 1;
      }

      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    resultsPerPage() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterOnlyExpiredContracts() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterHideInactiveContracts() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterOnlyMyContracts() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterHidePublishedContracts() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    hasAve() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    hasAnhang1() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterOnlyLastVersion() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterOnlyUpdatedLastVersion() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    exact_version_valid_from() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    exact_version_valid_to() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    exact_ave_changes_from() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    exact_ave_changes_to() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    exact_ave_extend_to() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterResponsableUserId() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterControllerUserId() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterCriteriaStructureItem() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterContractResponsable() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
    filterContractTypeId() {
      this.currentPage = 1;
      this.GetAllContractsFiltered();
    },
  },
  created() {
    let that = this;

    GetContractTypes(
      (response) => {
        that.contractTypes = response.data;
      },
      (error) => {
        that.errorObject = error;
        that.isLoading = false;
      },
    );

    GetAveStatus(
      (result) => {
        for (var property in result.data) {
          that.aveStateList.push({
            id: parseInt(property),
            name: result.data[property],
          });
        }
      },
      (error) => {
        that.errorObject = error;
        that.isLoading = false;
      },
    );

    GetVersionStatus(
      (result) => {
        for (var property in result.data) {
          that.versionStatus.push({
            id: parseInt(property),
            name: result.data[property],
          });
        }
      },
      (error) => {
        that.errorObject = error;
        that.isLoading = false;
      },
    );

    GetVersionTags(
      (response) => {
        if (response.data.length) {
          response.data.forEach((tag) => {
            this.versionTags.push(tag.tagName);
          });
        }
      },
      (error) => {
        this.errorObject = error;
      },
    );

    GetAvailableTenants(
      (response) => {
        this.availableTenants = response;
      },
      () => {
        this.availableTenants = [];
      },
    );

    GetAnhang1Status(
      (result) => {
        for (var property in result.data) {
          this.anhang1Status.push({
            id: parseInt(property),
            name: result.data[property],
          });
        }
      },
      (error) => {
        this.errorObject = error;
        this.isLoading = false;
      },
    );

    GetContractResponsables(
      (result) => {
        if (result) {
          this.contractResponsables = result;
        }
      },
      (error) => {
        this.errorObject = error;
        this.isLoading = false;
      },
    );

    GetVersionResponsables(
      (result) => {
        if (result) {
          this.versionResponsables = result;
        }
      },
      (error) => {
        this.errorObject = error;
        this.isLoading = false;
      },
    );

    GetCriteriaStructurelist(
      (result) => {
        if (result) {
          this.criteriaStructurelist = result;
        }
      },
      (error) => {
        this.errorObject = error;
        this.isLoading = false;
      },
    );

    this.$eventBus.$on("bookmarkUpdated", () => {
      this.GetAllContractsFiltered();
    });
  },
  mounted() {
    this.loadLastSearch(() => {
      this.GetAllContractsFiltered();
    });
  },

  methods: {
    filterVersionresponsables(option, search) {
      return (
        option.firstname.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        option.lastname.toLowerCase().indexOf(search.toLowerCase()) > -1
      );
    },
    filterCriteriaStructure(option, search) {
      return option.code.toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    filterContractresponsables(option, search) {
      return option.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    validDays(year, month) {
      return Array.from(
        { length: this.lastDayInMonth(year, month) },
        (_, index) => index + 1,
      );
    },
    lastDayInMonth(year, month) {
      return new Date(year, month, 0).getDate();
    },
    checkDate(year, month, day, date, validDay) {
      if (!year && !month && !day) {
        date = "";
      } else {
        // Wenn das Jahr leer ist, das aktuelle Jahr verwenden
        if (!year) {
          year = new Date().getFullYear();
        }

        // Wenn der Monat leer ist, den aktuellen Monat verwenden
        if (!month) {
          if (validDay == "lastDay") {
            month = 12;
          } else {
            month = 1;
          }
        }

        // Wenn der Tag leer ist, den letzten Tag des Monats verwenden
        if (!day) {
          if (validDay == "lastDay") {
            day = new Date(year, month, 0).getDate();
          } else {
            day = 1;
          }
        }

        date = year + "-" + month + "-" + day + "T00:00:00";
      }

      return date;
    },

    getVersionState(versionId) {
      const currentState = this.versionStatus.find((status) => {
        return status.id == versionId;
      });

      if (currentState && "name" in currentState) {
        return currentState.name;
      } else {
        return "--";
      }
    },
    setBookmarksToContract() {
      this.merkListe = loadMerkliste();

      this.allContracts.forEach((contract) => {
        if (
          this.merkListe.find((listElement) => {
            return (
              contract.contractNumber == listElement.GavNumber &&
              contract.versionNumber == listElement.Version
            );
          })
        ) {
          contract.isBookmark = true;
        } else {
          contract.isBookmark = false;
        }

        GetAllEditions(
          contract.contractNumber,
          contract.versionNumber,
          (result) => {
            if (result && result.length) {
              contract.newestEditon = result[0].editionId;
            } else {
              contract.newestEditon = 0;
            }
          },
          (error) => {
            this.isLoading = false;
            this.errorObject = error;
          },
        );
      });
    },
    setBookmark(contract) {
      if (contract.isBookmark && contract.newestEditon) {
        addItemToMerkliste(
          contract.contractName,
          contract.versionNumber,
          contract.newestEditon,
          contract.contractNumber,
        );

        contract.isBookmark = true;
      } else {
        const deleteBookmarkIndex = this.merkListe.findIndex((listElement) => {
          return (
            listElement.GavNumber == contract.contractNumber &&
            listElement.Version == contract.versionNumber
          );
        });

        this.merkListe = removeSingleItemFromMerkliste(deleteBookmarkIndex);
        contract.isBookmark = false;
      }

      this.$eventBus.$emit("bookmarkAdded");
    },
    setBookmarkOnAll() {
      this.isActivAllResToBookmarks = true;
      var requestObject = {
        ContractNumberName: this.filterGavNumberName,
        ContractName: this.filterGavName,
        ContractNumber: this.filterGavNumber,
        SortBy: this.SortedProperty,
        SortOrder: this.SortOrder != -1 ? this.SortOrder.toString() : "",
        OutDatedContractsOnly: this.filterOnlyExpiredContracts,
        HideDeactivatedContracts: this.filterHideInactiveContracts,
        MyContractsOnly: this.filterOnlyMyContracts,
        HideUpdatedContracts: this.filterHidePublishedContracts,
        versionNumber: null,
        aveState: this.filterAveState.toString(),
        workflowStatusId: this.filterWorkflowStatus,
        isInternalOnly: false,
        Language: this.Language,
        AveStart: this.date_ave_changes_from,
        AveEnd: this.date_ave_changes_to,
        Ablaufdatum: this.date_ave_extend_to,
        VersionValidFrom: this.date_version_valid_from,
        VersionValidTo: this.date_version_valid_to,
        PageSize: Math.pow(2, 31) - 1, // Max Value INT32
        VersionTagList:
          this.filterVersionTag != -1 ? [this.filterVersionTag] : "",
        VersionState:
          this.filterVersionState != -1 ? this.filterVersionState : "",
        TenantId:
          this.filterVersionTenant != -1 ? this.filterVersionTenant : "",
        Anhang1State: this.filterAhnhang1State,
        OnlyLastVersion: this.filterOnlyLastVersion,
        OnlyUpdatedLastVersion: this.filterOnlyUpdatedLastVersion,
        HasAnhang1: this.hasAnhang1,
        ExactVersionFrom: this.exact_version_valid_from,
        ExactVersionTo: this.exact_version_valid_to,
        HasAve: this.hasAve,
        ExactAveStart: this.exact_ave_changes_from,
        ExactAveEnd: this.exact_ave_changes_to,
        ExactAblaufdatum: this.exact_ave_extend_to,
        ResponsableUserId: this.filterResponsableUserId,
        ControllerUserId: this.filterControllerUserId,
        CriteriaStructureItem: this.filterCriteriaStructureItem,
        ContractTypeId: this.filterContractTypeId,
        ContractResponsableCrmType: this.filterContractResponsable
          ? this.filterContractResponsable.crmType
          : "",
        ContractResponsableId: this.filterContractResponsable
          ? this.filterContractResponsable.id
          : "",
      };

      this.isLoading = true;

      let that = this;
      GetAllContracts(
        requestObject,
        (response) => {
          this.searchQueryQueue = [];

          if (response.data.contracts.length === 0) {
            this.isLoading = false;
            return;
          }

          let contractsToBookmark = response.data.contracts.map((contract) => {
            return {
              contractName: contract.contractName,
              versionNumber: contract.versionNumber,
              editionNumber: contract.newestEditon,
              contractNumber: contract.contractNumber,
            };
          });

          let editionPromises = [];
          let einrichedContracts = [];

          contractsToBookmark.map((contract) => {
            contract.isBookmark = true;

            editionPromises.push(
              new Promise((resolve, reject) => {
                GetAllEditions(
                  contract.contractNumber,
                  contract.versionNumber,
                  (result) => {
                    if (result && result.length) {
                      contract.editionNumber = result[0].editionId;
                    } else {
                      contract.editionNumber = 0;
                    }

                    einrichedContracts.push(contract);
                    resolve();
                  },
                  (error) => {
                    this.isLoading = false;
                    this.errorObject = error;
                    reject();
                  },
                );
              }),
            );
          });

          Promise.all(editionPromises).then(() => {
            addItemsToMerkliste(einrichedContracts);
            this.$eventBus.$emit("bookmarkAdded");

            this.isActivAllResToBookmarks = false;
            that.isLoading = false;
          });
        },
        (error) => {
          this.searchQueryQueue = [];
          that.isLoading = false;
          this.isActivAllResToBookmarks = false;
          that.errorObject = error;
        },
      );
    },
    SortedPropertyClicked(property) {
      if (this.SortedProperty == property) {
        switch (this.SortOrder) {
          case -1:
            this.SortOrder = 0;
            break;
          case 0:
            this.SortOrder = 1;
            break;
          case 1:
            this.SortOrder = -1;
            break;
          default:
            this.SortOrder = -1;
            break;
        }

        this.GetAllContractsFiltered();
      } else {
        this.SortedProperty = property;
      }
    },

    SortedReversePropertyClicked(property) {
      if (this.SortedProperty == property) {
        switch (this.SortOrder) {
          case -1:
            this.SortOrder = 1;
            break;
          case 0:
            this.SortOrder = -1;
            break;
          case 1:
            this.SortOrder = 0;
            break;
          default:
            this.SortOrder = -1;
            break;
        }

        this.GetAllContractsFiltered();
      } else {
        this.SortedProperty = property;
      }
    },

    GetAllContractsFiltered(immediateReload) {
      if (immediateReload) {
        this.filterSortContracts();
        return;
      }

      this.isLoading = true;
      this.errorObject = null;
      this.allContracts = [];

      this.searchQueryQueue.push(new Date().getTime());
      setTimeout(() => {
        if (this.searchQueryQueue.length > 1) {
          this.searchQueryQueue = this.searchQueryQueue.slice(1);
          return;
        }
        if (!this.disableLocalStorageSave) {
          this.saveCurrentSearch();
        } else {
          this.disableLocalStorageSave = false;
        }

        this.filterSortContracts();
      }, 400);
    },

    saveCurrentSearch() {
      let localStorageItem = "";
      if (!this.showAdvancedSearch) {
        localStorageItem = {
          ContractName: this.filterGavName,
          ContractNumber: this.filterGavNumber,
          ContractNumberName: this.filterGavNumberName,
        };
      } else {
        localStorageItem = {
          ContractName: this.filterGavName,
          ContractNumber: this.filterGavNumber,
          ContractNumberName: this.filterGavNumberName,
          VersionState: this.filterVersionState,
          OutDatedContractsOnly: this.filterOnlyExpiredContracts,
          HideDeactivatedContracts: this.filterHideInactiveContracts,
          MyContractsOnly: this.filterOnlyMyContracts,
          HideUpdatedContracts: this.filterHidePublishedContracts,
          aveState: this.filterAveState,
          workflowStatusId: this.filterWorkflowStatus,
          AveStart: this.date_ave_changes_from,
          AveEnd: this.date_ave_changes_to,
          Ablaufdatum: this.date_ave_extend_to,
          VersionValidFrom: this.date_version_valid_from,
          VersionValidTo: this.date_version_valid_to,
          VersionTagList: this.filterVersionTag,
          TenantId: this.filterVersionTenant,
          Anhang1State: this.filterAhnhang1State,
          OnlyLastVersion: this.filterOnlyLastVersion,
          OnlyUpdatedLastVersion: this.filterOnlyUpdatedLastVersion,
          HasAnhang1: this.hasAnhang1,
          ExactVersionFrom: this.exact_version_valid_from,
          ExactVersionTo: this.exact_version_valid_to,
          HasAve: this.hasAve,
          ExactAveStart: this.exact_ave_changes_from,
          ExactAveEnd: this.exact_ave_changes_to,
          ExactAblaufdatum: this.exact_ave_extend_to,
          ResponsableUserId: this.filterResponsableUserId,
          ControllerUserId: this.filterControllerUserId,
          CriteriaStructureItem: this.filterCriteriaStructureItem,
          ContractTypeId: this.filterContractTypeId,
          ContractResponsableCrmType: this.filterContractResponsable,
          ContractResponsableId: this.filterContractResponsable,
          year_ave_changes_from: this.year_ave_changes_from,
          month_ave_changes_from: this.month_ave_changes_from,
          day_ave_changes_from: this.day_ave_changes_from,
          date_ave_changes_from: this.date_ave_changes_from,
          year_ave_changes_to: this.year_ave_changes_to,
          month_ave_changes_to: this.month_ave_changes_to,
          day_ave_changes_to: this.day_ave_changes_to,
          date_ave_changes_to: this.date_ave_changes_to,
          year_ave_extend_to: this.year_ave_extend_to,
          month_ave_extend_to: this.month_ave_extend_to,
          day_ave_extend_to: this.day_ave_extend_to,
          date_ave_extend_to: this.date_ave_extend_to,
          year_version_valid_from: this.year_version_valid_from,
          month_version_valid_from: this.month_version_valid_from,
          day_version_valid_from: this.day_version_valid_from,
          date_version_valid_from: this.date_version_valid_from,
          year_version_valid_to: this.year_version_valid_to,
          month_version_valid_to: this.month_version_valid_to,
          day_version_valid_to: this.day_version_valid_to,
          date_version_valid_to: this.date_version_valid_to,
        };
      }

      window.localStorage.setItem(
        UniaGAVConstants.LocalStorageKeys.AdminSearch,
        JSON.stringify(localStorageItem),
      );
    },
    loadLastSearch(callback) {
      var searchTerms = window.localStorage.getItem(
        UniaGAVConstants.LocalStorageKeys.AdminSearch,
      );

      if (searchTerms) {
        this.filterGavName = JSON.parse(searchTerms).ContractName;
        this.filterGavNumber = JSON.parse(searchTerms).ContractNumber;
        this.filterGavNumberName = JSON.parse(searchTerms).ContractNumberName;
        if (this.showAdvancedSearch) {
          const localStorageSearchTerms = JSON.parse(searchTerms);
          this.filterVersionState = localStorageSearchTerms.VersionState || -1;
          this.filterOnlyExpiredContracts =
            localStorageSearchTerms.OutDatedContractsOnly || false;
          this.filterHideInactiveContracts =
            localStorageSearchTerms.HideDeactivatedContracts || false;
          this.filterOnlyMyContracts =
            localStorageSearchTerms.MyContractsOnly || false;
          this.filterHidePublishedContracts =
            localStorageSearchTerms.HideUpdatedContracts || false;
          this.filterAveState = localStorageSearchTerms.aveState || -1;
          this.filterWorkflowStatus =
            localStorageSearchTerms.workflowStatusId || -1;

          this.date_ave_changes_from = localStorageSearchTerms.AveStart || "";
          this.date_ave_changes_to = localStorageSearchTerms.AveEnd || "";
          this.date_ave_extend_to = localStorageSearchTerms.Ablaufdatum || "";

          this.date_version_valid_from =
            localStorageSearchTerms.VersionValidFrom || "";

          this.date_version_valid_to =
            localStorageSearchTerms.VersionValidTo || "";

          this.filterVersionTag = localStorageSearchTerms.VersionTagList || -1;

          this.filterVersionTenant = localStorageSearchTerms.TenantId || -1;

          this.filterAhnhang1State = localStorageSearchTerms.Anhang1State || -1;

          this.filterOnlyLastVersion =
            localStorageSearchTerms.OnlyLastVersion || false;

          this.filterOnlyUpdatedLastVersion =
            localStorageSearchTerms.OnlyUpdatedLastVersion || false;
          this.hasAnhang1 = localStorageSearchTerms.HasAnhang1 || false;
          this.exact_version_valid_from =
            localStorageSearchTerms.ExactVersionFrom || "";
          this.exact_version_valid_to =
            localStorageSearchTerms.ExactVersionTo || "";
          this.hasAve = localStorageSearchTerms.HasAve || false;
          this.exact_ave_changes_from =
            localStorageSearchTerms.ExactAveStart || false;
          this.exact_ave_changes_to =
            localStorageSearchTerms.ExactAveEnd || false;
          this.exact_ave_extend_to =
            localStorageSearchTerms.ExactAblaufdatum || false;
          this.filterResponsableUserId =
            localStorageSearchTerms.ResponsableUserId || "";
          this.filterControllerUserId =
            localStorageSearchTerms.ControllerUserId || "";
          this.filterCriteriaStructureItem =
            localStorageSearchTerms.CriteriaStructureItem || "";

          this.filterContractTypeId =
            localStorageSearchTerms.ContractTypeId || "";
          this.filterContractResponsable =
            localStorageSearchTerms.ContractResponsableCrmType || "";
          this.filterContractResponsable =
            localStorageSearchTerms.ContractResponsableId || "";
          this.year_ave_changes_from =
            localStorageSearchTerms.year_ave_changes_from || "";
          this.month_ave_changes_from =
            localStorageSearchTerms.month_ave_changes_from || "";
          this.date_ave_changes_from =
            localStorageSearchTerms.date_ave_changes_from || "";
          this.year_ave_changes_to =
            localStorageSearchTerms.year_ave_changes_to || "";
          this.month_ave_changes_to =
            localStorageSearchTerms.month_ave_changes_to || "";
          this.day_ave_changes_to =
            localStorageSearchTerms.day_ave_changes_to || "";
          this.date_ave_changes_to =
            localStorageSearchTerms.date_ave_changes_to || "";
          this.year_ave_extend_to =
            localStorageSearchTerms.year_ave_extend_to || "";
          this.month_ave_extend_to =
            localStorageSearchTerms.month_ave_extend_to || "";
          this.day_ave_extend_to =
            localStorageSearchTerms.day_ave_extend_to || "";
          this.date_ave_extend_to =
            localStorageSearchTerms.date_ave_extend_to || "";
          this.year_version_valid_from =
            localStorageSearchTerms.year_version_valid_from || "";
          this.month_version_valid_from =
            localStorageSearchTerms.month_version_valid_from || "";
          this.day_version_valid_from =
            localStorageSearchTerms.day_version_valid_from || "";
          this.date_version_valid_from =
            localStorageSearchTerms.date_version_valid_from || "";
          this.year_version_valid_to =
            localStorageSearchTerms.year_version_valid_to || "";
          this.month_version_valid_to =
            localStorageSearchTerms.month_version_valid_to || "";
          this.day_version_valid_to =
            localStorageSearchTerms.day_version_valid_to || "";
          this.date_version_valid_to =
            localStorageSearchTerms.date_version_valid_to || "";
          this.day_ave_changes_from =
            localStorageSearchTerms.day_ave_changes_from || "";
        }
      }

      callback();
    },

    filterSortContracts() {
      var requestObject = {
        ContractNumberName: this.filterGavNumberName,
        ContractName: this.filterGavName,
        ContractNumber: this.filterGavNumber,
        PageNumber: this.currentPage,
        SortBy: this.SortedProperty,
        SortOrder: this.SortOrder != -1 ? this.SortOrder.toString() : "",
        OutDatedContractsOnly: this.filterOnlyExpiredContracts,
        HideDeactivatedContracts: this.filterHideInactiveContracts,
        MyContractsOnly: this.filterOnlyMyContracts,
        HideUpdatedContracts: this.filterHidePublishedContracts,
        PageSize: this.resultsPerPage,
        versionNumber: null,
        aveState: this.filterAveState.toString(),
        workflowStatusId: this.filterWorkflowStatus,
        isInternalOnly: false,
        Language: this.Language,
        AveStart: this.date_ave_changes_from,
        AveEnd: this.date_ave_changes_to,
        Ablaufdatum: this.date_ave_extend_to,
        VersionValidFrom: this.date_version_valid_from,
        VersionValidTo: this.date_version_valid_to,
        VersionTagList:
          this.filterVersionTag != -1 ? [this.filterVersionTag] : "",
        VersionState:
          this.filterVersionState != -1 ? this.filterVersionState : "",
        TenantId:
          this.filterVersionTenant != -1 ? this.filterVersionTenant : "",
        Anhang1State: this.filterAhnhang1State,
        OnlyLastVersion: this.filterOnlyLastVersion,
        OnlyUpdatedLastVersion: this.filterOnlyUpdatedLastVersion,
        HasAnhang1: this.hasAnhang1,
        ExactVersionFrom: this.exact_version_valid_from,
        ExactVersionTo: this.exact_version_valid_to,
        HasAve: this.hasAve,
        ExactAveStart: this.exact_ave_changes_from,
        ExactAveEnd: this.exact_ave_changes_to,
        ExactAblaufdatum: this.exact_ave_extend_to,
        ResponsableUserId: this.filterResponsableUserId,
        ControllerUserId: this.filterControllerUserId,
        CriteriaStructureItem: this.filterCriteriaStructureItem,
        ContractTypeId: this.filterContractTypeId,
        ContractResponsableCrmType: this.filterContractResponsable
          ? this.filterContractResponsable.crmType
          : "",
        ContractResponsableId: this.filterContractResponsable
          ? this.filterContractResponsable.id
          : "",
      };

      this.isLoading = true;
      let that = this;
      GetAllContracts(
        requestObject,
        (response) => {
          this.searchQueryQueue = [];
          this.fromContracts =
            this.currentPage * this.resultsPerPage - this.resultsPerPage;

          this.toContracts = this.currentPage * this.resultsPerPage;
          if (response.data.numberOfItems < this.toContracts) {
            this.toContracts = response.data.numberOfItems;
          }

          this.totalNumberOfContracts = response.data.numberOfItems;
          that.allContracts = response.data.contracts;
          this.setBookmarksToContract();
          that.isLoading = false;
        },
        (error) => {
          this.searchQueryQueue = [];
          that.isLoading = false;
          that.errorObject = error;
        },
      );
    },
    resetFilters() {
      //  reset all filters
      this.filterGavNumberName = "";
      this.filterGavName = "";
      this.filterGavNumber = "";
      this.filterWorkflowStatus = -1;
      this.filterOnlyMyContracts = false;
      this.filterHidePublishedContracts = false;
      this.filterHideInactiveContracts = false;
      this.filterOnlyExpiredContracts = false;
      this.filterAveState = -1;
      //Versionen, deren AVE Änderungen gültig ab
      this.year_ave_changes_from = "";
      this.month_ave_changes_from = "";
      this.day_ave_changes_from = "";
      this.date_ave_changes_from = "";
      //Versionen, deren AVE Änderungen gültig bis
      this.year_ave_changes_to = "";
      this.month_ave_changes_to = "";
      this.day_ave_changes_to = "";
      this.date_ave_changes_to = "";
      //Versionen, deren Künstliche Verlängerung gültig bis
      this.year_ave_extend_to = "";
      this.month_ave_extend_to = "";
      this.day_ave_extend_to = "";
      this.date_ave_extend_to = null;
      //Versionen, die ab «Datum» gültig sind
      this.year_version_valid_from = "";
      this.month_version_valid_from = "";
      this.day_version_valid_from = "";
      this.date_version_valid_from = null;
      //Versionen, die bis «Datum» gültig sind
      this.year_version_valid_to = "";
      this.month_version_valid_to = "";
      this.day_version_valid_to = "";
      this.date_version_valid_to = null;

      this.filterVersionState = -1;
      this.filterVersionTag = -1;
      this.filterVersionTenant = -1;
      this.filterAhnhang1State = -1;

      this.filterOnlyLastVersion = false;
      this.filterOnlyUpdatedLastVersion = false;
      this.hasAnhang1 = false;
      this.exact_version_valid_from = false;
      this.exact_version_valid_to = false;
      this.hasAve = false;
      this.exact_ave_changes_from = false;
      this.exact_ave_changes_to = false;
      this.exact_ave_extend_to = false;
      this.filterResponsableUserId = "";
      this.filterControllerUserId = "";
      this.filterCriteriaStructureItem = "";
      this.filterContractTypeId = "";
      this.filterContractResponsable = "";
    },
    hideShowAdvancedSearch() {
      this.showAdvancedSearch = !this.showAdvancedSearch;

      this.loadLastSearch(() => {
        this.GetAllContractsFiltered();
      });

      // if advanced search is hidden, reset advanced filters
      if (!this.showAdvancedSearch) {
        // Todo: reset advaned Filters
      }
    },
  },
};
</script>

<style scoped>
/* /deep/ means that the Css-rule aplies to all child-components
All classes in this section are targeted at the pagination-component */

.custom-select.filled-input {
  border-bottom-color: #e72b37;
  background-color: #ededed;
  font-weight: bold;
  color: #333;
}

.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #aaa;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  padding: 0 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus {
  outline: none;
  border-bottom: 2px solid #333;
  color: #333;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

/* CSS für den Pfeil */
.custom-select:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  margin-top: -4px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus:after {
  margin-top: -2px;
  border-top: 5px solid #fdd;
  transform: rotate(180deg);
}

.custom-input.filled-input {
  color: #333 !important;
  border-bottom-color: #333;
  background-color: #fff !important;
}

.custom-input {
  position: relative;
  display: block;
  width: 100%;
  height: 40px;
  color: #aaa !important;
  background-color: #fff !important;
  background-image: none !important;
  border: none;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 0 10px;
  transition: all 0.3s ease-in-out;
}

.custom-input:focus {
  outline: none;
  border-bottom: 2px solid #333;
  background-color: white !important;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.custom-input:focus-visible {
  outline: none;
  background-color: white !important;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

/* CSS für das Unterstrich-Element */
.custom-input-underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #fdd;
  transition: all 0.3s ease-in-out;
}

.custom-input:focus + .custom-input-underline,
.custom-input:not(:placeholder-shown) + .custom-input-underline {
  background-color: #333;
}

/deep/ .page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #ff5959;
  border-color: #e72b37;
}

/deep/ .page-link:hover {
  z-index: 2;
  color: #e72b37;
  text-decoration: none;
  background-color: #fdd;
  border-color: #fdd;
}

/deep/ a:hover {
  color: #0056b3;
  text-decoration: underline;
}

/deep/ .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #e72b37;
  background-color: rgb(255, 255, 255);
  border: 1px solid #dee2e6;
}

/deep/ .tableHeader {
  border-bottom: 1px solid #909090;
  font-weight: bold;
}

/*
to hide first and last button of pager, add this css
/deep/ li.page-item:last-child,
li.page-item:first-child {
  display: none;
} */
</style>

<style scoped>
.advancedSearchButtonsWrapper {
  width: 100%;
  margin-bottom: 30px;
  display: inline-block;
  text-align: right;
}

.cursor-pointer {
  cursor: pointer;
}

.contractsTableGavNumber {
  width: 12%;
}

.contractsTableLastChange {
  width: 11%;
}

.contractsTableName {
  width: 21%;
}

.contractsTableStart {
  width: 7%;
}

.contractsTableEnd {
  width: 7%;
}

.contractsTableVersion {
  width: 7%;
}

.contractsTableWfStatus {
  width: 9%;
}

.contractsTableAveStatus {
  width: 13%;
}

.contractsTableVersionState {
  width: 10%;
}

.rTable {
  display: table;
  width: 100%;
}

.rTableRow {
  display: table-row;
  padding: 12px 0px 12px 0px;
}

.rTableCell,
.rTableHead {
  display: table-cell;
  padding: 10px 8px;
}

.rTableHead {
  font-weight: bold;
  border-bottom: 1px solid #a7a7a7 !important;
}

.rTableCell {
  border-bottom: 1px solid #dcdcdc !important;
}

#contractsSearchAdvancedArguments {
  overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s;
}

.slide-enter,
.slide-leave-to {
  height: 0;
  opacity: 0;
}

.slide-enter-to,
.slide-leave {
  height: 180px;
  opacity: 1;
}
</style>
